module.exports = __webpack_public_path__ + "img/back.76eb87fb.svg";